import type { HarnessMessage, HarnessPart } from "../types"
import { run } from "../run"
import { designerContext, DESIGNER_PROMPT } from "./prompt"
import { designerTools } from "./tools"
import type { LanguageModelV1 } from "ai"

export { fakeDesigner } from "./fake"

const THINKING = 4000

interface DesignerTurn {
  model: LanguageModelV1
  playbook: Playbook
  history: HarnessMessage[]
  message: string
  onChange: (playbook: Playbook) => void
  onParts: (parts: HarnessPart[]) => void
}

// One turn of the designer over the playbook as it is when the turn starts
export function design({ model, playbook, history, message, onChange, onParts }: DesignerTurn) {
  const tools = designerTools(playbook, onChange)
  return run({ model, system: DESIGNER_PROMPT, context: designerContext(playbook), history, message, tools, thinking: THINKING, onParts })
}
